export default __webpack_public_path__ + "static/media/MinusDelete.43d91929.svg";